import { Search, Store, Check } from "lucide-react";
import { cn } from "@/lib/utils";

const OPTIONS = [
  { value: "pelanggan", title: "Saya butuh jasa", desc: "Minta penawaran gratis dari penyedia terpercaya.", Icon: Search },
  { value: "penyedia", title: "Saya penyedia jasa", desc: "Dapatkan pelanggan baru dan kirim penawaran.", Icon: Store },
];

export const RolePicker = ({ value, onChange }) => (
  <div className="grid gap-3 sm:grid-cols-2" data-testid="role-picker">
    {OPTIONS.map(({ value: v, title, desc, Icon }) => {
      const active = value === v;
      return (
        <button
          key={v}
          type="button"
          data-testid={`role-option-${v}`}
          onClick={() => onChange(v)}
          className={cn(
            "relative flex flex-col items-start gap-2 rounded-2xl border p-4 text-left transition-[border-color,background-color,box-shadow] duration-150",
            active ? "border-teal-600 bg-teal-50/60 shadow-[0_0_0_3px_rgba(15,118,110,0.12)]" : "border-stone-200 bg-white hover:border-stone-300"
          )}
        >
          <span className={cn("flex h-9 w-9 items-center justify-center rounded-xl", active ? "bg-teal-700 text-white" : "bg-stone-100 text-stone-600")}>
            <Icon className="h-4 w-4" />
          </span>
          <span className="text-sm font-bold text-stone-900">{title}</span>
          <span className="text-xs leading-relaxed text-stone-500">{desc}</span>
          {active && <Check className="absolute right-4 top-4 h-4 w-4 text-teal-700" />}
        </button>
      );
    })}
  </div>
);
